"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const intl_1 = require("@kyruus/intl");
/**
 * Internationalized messages for AppointmentWaitlist widget
 * These get passed through `React-Intl`
 */
exports.default = (0, intl_1.defineMessages)({
    // Date of Birth Confirmation
    dobConfirmationHeading: {
        id: 'appointmentWaitlist.dobConfirmation.heading',
        description: 'Heading message explaining need to confirm date of birth before rescheduling appointment',
        defaultMessage: 'Before we reschedule your appointment, we need to confirm your date of birth.'
    },
    dobInfoMessage: {
        id: 'appointmentWaitlist.dobConfirmation.dobInfoMessage',
        description: 'Informational message explaining why date of birth is required for waitlist registration',
        defaultMessage: 'Earlier appointment times are not available anymore. Your original appointment with {provider_name} on {appointment_time} has not changed. You are still on the waitlist.'
    },
    continueButton: {
        id: 'appointmentWaitlist.dobConfirmation.continueButton',
        description: 'Label for the continue button to proceed after entering date of birth',
        defaultMessage: 'Continue'
    },
    ariaConfirmDateOfBirthContinueButtonLabel: {
        id: 'appointmentWaitlist.dobConfirmation.ariaConfirmDateOfBirthContinueButtonLabel',
        description: 'Aria label for the continue button to confirm date of birth',
        defaultMessage: 'Continue with date of birth confirmation'
    },
    // Validation banner messages
    dobValidationError: {
        id: 'appointmentWaitlist.dobConfirmation.dobValidationError',
        description: 'Error message when date of birth is invalid',
        defaultMessage: 'Date of birth is not valid'
    },
    dobValidationFailureBanner: {
        id: 'appointmentWaitlist.dobConfirmation.dobValidationFailureBanner',
        description: 'Banner message when date of birth validation fails',
        defaultMessage: 'We are having trouble validating your date of birth. Please try again.'
    },
    dobLabel: {
        id: 'appointmentWaitlist.dobConfirmation.dobLabel',
        description: 'Label for the date of birth input with required asterisk',
        defaultMessage: 'Date of Birth *'
    }
});
//# sourceMappingURL=messages.js.map